// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The VisBug-style card shown next to the element under the pointer while Alt is held. */
.w0tVJsQuAGuefXVSkH9T {
  position: absolute;
  display: none;
  max-width: 300px;
  padding: 8px 10px;
  border-radius: 6px;
  pointer-events: none;
  background: #23272f;
  color: #f6f7f9;
  font: 500 11px/1.5 -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}
/* div#id.class-a.class-b — hashed class names have no spaces, so allow breaks anywhere. */
.x0xCoxWS3a2EuEkKD7St {
  color: #c4b5fd;
  font-weight: 600;
  word-break: break-all;
}
.mczwzm7d9p1ASV0puBlg {
  margin-bottom: 4px;
  color: #a855f7;
  font-weight: 600;
}
._gMEq4LDc9vB93rfn4ai {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-variant-numeric: tabular-nums;
}
.fIkMmp0W1hjaGsX3UwCe {
  color: #9ca3af;
}
.o_o_jYVbv6A_BwBuTSvz {
  display: inline-block;
  width: 9px;
  height: 9px;
  margin-right: 4px;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/features/qaPanel/measure/styles/elementInfo.module.css"],"names":[],"mappings":"AAAA,yFAAyF;AACzF;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,4EAA4E;EAC5E,yCAAyC;AAC3C;AACA,0FAA0F;AAC1F;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;AACjD","sourcesContent":["/* The VisBug-style card shown next to the element under the pointer while Alt is held. */\n.card {\n  position: absolute;\n  display: none;\n  max-width: 300px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  pointer-events: none;\n  background: #23272f;\n  color: #f6f7f9;\n  font: 500 11px/1.5 -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n}\n/* div#id.class-a.class-b — hashed class names have no spaces, so allow breaks anywhere. */\n.selector {\n  color: #c4b5fd;\n  font-weight: 600;\n  word-break: break-all;\n}\n.size {\n  margin-bottom: 4px;\n  color: #a855f7;\n  font-weight: 600;\n}\n.row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  font-variant-numeric: tabular-nums;\n}\n.name {\n  color: #9ca3af;\n}\n.swatch {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  margin-right: 4px;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.35);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `w0tVJsQuAGuefXVSkH9T`,
	"selector": `x0xCoxWS3a2EuEkKD7St`,
	"size": `mczwzm7d9p1ASV0puBlg`,
	"row": `_gMEq4LDc9vB93rfn4ai`,
	"name": `fIkMmp0W1hjaGsX3UwCe`,
	"swatch": `o_o_jYVbv6A_BwBuTSvz`
};
export default ___CSS_LOADER_EXPORT___;
